module.exports = __webpack_public_path__ + "static/media/clinician-leads-to-stroke-preview@2x.9e8112d6.png";